import React from 'react';

import type { IconBaseProps } from '@fmbt/ui/icons';

import SecurityCameraIcon from './security-camera.svg?react';

export default function FarmbotSecurityCameraIcon({ size, ...props }: IconBaseProps) {
  return (
    <SecurityCameraIcon
      width={size || 18}
      height={size || 18}
      {...props}
    />
  );
}
